// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__2OuB7"};